var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"helper-step"},[_c('CatalogFiltersBasic',{attrs:{"label":"Type de prestation","kind":"categories"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }